import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=046b4aee&scoped=true"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocol.vue?vue&type=style&index=0&id=046b4aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b4aee",
  null
  
)

export default component.exports